import { Box, DashboardModule } from '@domain-group/suit-theme'

import useAssignTemplatePagePermissions from '../../hooks/useAssignTemplatePagePermissionsModal'

import EntityFilters from '../EntityFilters'
import EntityList from '../EntityList'

import BrandTheme from './BrandTheme'

interface BrandThemesProps {
  assignTemplatePagePermissionsPayload: ReturnType<typeof useAssignTemplatePagePermissions>,
}

const BrandThemes = (props: BrandThemesProps) => {
  const { assignTemplatePagePermissionsPayload } = props

  return (
    <DashboardModule title="Brand Themes">
      <Box flexDirection="column" padding="large">
        <EntityFilters
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityName="Brand Themes"
        />

        <EntityList
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityKey="brandThemeIds"
          entityListItemComponent={BrandTheme}
        />
      </Box>
    </DashboardModule>
  )
}

export default BrandThemes
